import {commitMutation, graphql} from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation UpdateWidgetMutation(
    $input: UpdateWidgetInput!
  ) {
    updateWidget(input: $input) {
      widget {
        id
        mongoId
        name
        type
        config {
          filterComments
          sliceByQuestion
          aggregateQuestions
          subtitle
          ignoreDateFilter
          showLastXMonths
          hideHeader
          hideCommentTime
          staticYAxisScale
          commentExtraColumns {
            title
            questionId
          }
          question {
            id
            firstAnswerTime
          }
        }
      }
    }
  }
`;

function commit({widgetId, name, type, config}) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          widgetId,
          name,
          type,
          config: {
            filterComments: config.filterComments,
            sliceByQuestion: config.sliceByQuestion,
            aggregateQuestions: config.aggregateQuestions,
            subtitle: config.subtitle,
            ignoreDateFilter: config.ignoreDateFilter,
            showLastXMonths: config.showLastXMonths,
            hideHeader: config.hideHeader,
            hideCommentTime: config.hideCommentTime,
            staticYAxisScale: config.staticYAxisScale,
            commentExtraColumns: config.commentExtraColumns,
            question: config.question,
          },
        },
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/UpdateWidgetMutation.js